'use client';

import { c as _c } from "react/compiler-runtime";
import { Close } from '@svenskaspelab/poolbetting/ui/TipsenSheet';
import type { PropsWithChildren, ReactNode } from 'react';
import { useFormStatus } from 'react-dom';
type FormSubmitButtonProps = PropsWithChildren<{
  form: string;
}>;

/**
 * Form submission component. Handles pending state.
 *
 * @param root0 component props
 * @param root0.children children of the component
 * @param root0.form form id to submit
 * @returns react node
 */
export default function FormSubmitButton(t0) {
  const $ = _c(4);
  const {
    children,
    form
  } = t0;
  const {
    pending: isPending
  } = useFormStatus();
  let t1;
  if ($[0] !== children || $[1] !== form || $[2] !== isPending) {
    t1 = <Close aria-disabled={isPending} disabled={isPending} form={form} type="submit">{children}</Close>;
    $[0] = children;
    $[1] = form;
    $[2] = isPending;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}